<template>
    <l-container>
        <l-container-title slot="toolbar" text="Historical data" icon="chart-bar" color="bg-pastel-red" />
        <div v-show="true" class="w-full flex flex-col">
            <ul class="flex ml-1">
                <li class="mr-6">Date shortcuts:</li>
                <li class="mr-6">
                    <a class="text-blue-500 hover:text-blue-800" href="#" @click="setDateThisWeek">this week</a>
                </li>
                <li class="mr-6">
                    <a class="text-blue-500 hover:text-blue-800" href="#" @click="setDateLastWeek">last week</a>
                </li>
                <li class="mr-6">
                    <a class="text-blue-500 hover:text-blue-800" href="#" @click="setDateLastMonth">last month</a>
                </li>
                <li class="mr-6">
                    <a class="text-blue-500 hover:text-blue-800" href="#" @click="setDateThisYear">this year</a>
                </li>
                <li class="mr-6">
                    <a class="text-blue-500 hover:text-blue-800" href="#" @click="setDateLastYear">last year</a>
                </li>
            </ul>
            <div class="flex mt-1">
                <!-- FROMTIME -->
                <div class="mr-4">
                    <vue-ctk-date-time-picker v-model="dateRangeFrom" :no-value-to-custom-elem="true" input-size="sm" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" label="Select from time" button-now-translation="Now" color="#7fa99b" :no-clear-button="true" :no-header="true">
                        <l-input v-model="dateRangeFrom" type="text" placeholder>
                            <template slot="prefix">
                                <font-awesome-icon icon="clock" class="text-base text-gray-500" />
                            </template>
                        </l-input>
                    </vue-ctk-date-time-picker>
                </div>

                <!-- TOTIME -->
                <div class="mr-4">
                    <vue-ctk-date-time-picker v-model="dateRangeTo" :no-value-to-custom-elem="true" input-size="sm" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" label="Select to time" button-now-translation="Now" color="#7fa99b" :no-clear-button="true" :no-header="true">
                        <l-input v-model="dateRangeTo" type="text" placeholder>
                            <template slot="prefix">
                                <font-awesome-icon icon="clock" class="text-base text-gray-500" />
                            </template>
                        </l-input>
                    </vue-ctk-date-time-picker>
                </div>
            </div>

            <div class="flex mt-4 w-full">
                <l-l-fav @click="onFavClick" :type="computedFavType" class="mr-1" />
                <div class="w-full">
                    <l-select v-model="timeseriesSelection" class="text-xs" :data="timeseriesWithinDateRange" placeholder="Please select a timeserie" :multiple="true">
                        <l-input v-model="q" placeholder="Search" type="search">
                            <template slot="suffix">
                                <font-awesome-icon icon="search" class="text-3xs text-gray-dark" />
                            </template>
                        </l-input>
                        <l-option v-for="i in filteredTimeseries" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
                    </l-select>
                </div>
                <div class="ml-1 mt-1">
                    <font-awesome-icon icon="backspace" class="text-base text-gray-600 hover:text-pastel-blue hover:cursor-pointer mt-1" @click="clearTimeseriesSelection" />
                </div>
            </div>

            <!-- AGGREGATION -->
            <div class="flex mt-4">
                <div class="mr-4 flex">
                    <l-select v-model="meantype" class="text-xs" :data="meantypes">
                        <l-option v-for="i in meantypes" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
                    </l-select>
                    <div class="ml-2 flex">
                        <label class="mr-1 self-center">Coverage:</label>
                        <l-input v-model="coverage">
                            <template v-slot:suffix>%</template>
                        </l-input>
                    </div>
                </div>
            </div>

            <!-- OPTIONS -->
            <div class="flex mt-4">
                <l-checkbox class="mr-4" v-model="onlyValidValues" label="Show only valid values"></l-checkbox>
                <l-checkbox class="mr-4" v-model="viewAsBar">
                    View chart as <i> <b>bar type</b> </i>
                </l-checkbox>
                <l-checkbox class="mr-4" v-if="false" v-model="setYaxisStart">Set Y-axis startvalue</l-checkbox>
            </div>
            <div class="flex mt-4" v-if="setYaxisStart">
                <label for="yaxisStartInput" class="flex mr-1 mt-2">Y-axis:</label>
                <l-input id="yaxisStartInput" v-model="yaxisStart" type="number" style="width: 100px"></l-input>
            </div>
            <div class="flex mt-4">
                <div class="mt-1">
                    <l-button type="success" :disabled="timeseriesSelection == null || timeseriesSelection.length == 0" @click="onClick">View timeseries</l-button>
                </div>
                <div class="px-2 h-10 ml-2 rounded-full flex items-center bg-gray-200" style="width: 320px">
                    <div class="text-xs pt-1 pl-2">
                        <l-checkbox class="mr-4" v-model="CsvFormatPivot">Pivot Csv</l-checkbox>
                    </div>
                    <l-button type="success" class="pl-2 pb-1 ml-2" style="width: 160px" @click="onDownloadCsv" :disabled="timeseriesSelection.length == 0 || loading">
                        <font-awesome-icon icon="download" class="text-xl text-white font-medium mr-4 pl-0" />
                        <span>Download CSV</span>
                    </l-button>
                </div>
                <div class="mt-1 ml-2 flex">
                    <l-ToolTip text="Copy link (with selections) to the clipboard" direction="top">
                        <l-button ref="btnUrlCopy" style="padding-left: 4px; width: 30px" @click="onCopyUrl">
                            <font-awesome-icon icon="link" alt="Copy URL" class="text-xl text-white font-medium" />
                        </l-button>
                    </l-ToolTip>
                    <input type="hidden" id="hdnCopyUrl" :value="copyUrl" />
                </div>
            </div>
        </div>
    </l-container>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import * as moment from "moment";
import HistoricalService from "@/helpers/services/viewer/historical.service";
import LocalService from "@/helpers/services/local.service";

import LLFav from "./LLFav";
import Notify from "@/helpers/notify";

import { LSelect, LOption, LButton, LInput, LCheckbox, LToolTip } from "@/components/forms";
export default {
    name: "LLSelection",
    components: {
        LInput,
        LSelect,
        LOption,
        LButton,
        LCheckbox,
        VueCtkDateTimePicker,
        LLFav,
        LToolTip,
    },
    props: [],
    data() {
        return {
            loading: false,
            q: "",
            timeseries: [],
            timeseriesSelection: [],
            dateRangeFrom: moment().add(-1, "months").format("YYYY-MM-DD"),
            dateRangeTo: moment().add(1, "days").format("YYYY-MM-DD"),
            onlyValidValues: true,
            viewAsBar: false,
            showCoverageInput: false,
            coverage: 0,
            setYaxisStart: false,
            yaxisStart: undefined,
            CsvFormatPivot: false,
            showUrlTooltip: false,
            copyUrl: null,
            preselected: [],
            coverage: 75,
            meantype: -1,
            meantypes: [
                { label: "Orginal", value: -1, format: "DD/MM HH:mm" },
                { label: "Hour", value: 1, format: "DD/MM HH:mm" },
                { label: "Day", value: 2, format: "DD/MM" },
                { label: "Movingday", value: 5, format: "DD/MM" },
                { label: "Moving eigth hour", value: 3, format: "DD/MM HH:mm" },
                { label: "Moving eigth hour max", value: 6, format: "DD/MM" },
                { label: "Month", value: 7, format: "MM/YYYY" },
                { label: "Year", value: 4, format: "YYYY" },
                { label: "Winter year", value: 8, format: "YYYY" },
                { label: "Winter season", value: 11, format: "YYYY" },
                { label: "Summer year", value: 12, format: "YYYY" },
                { label: "AOT40 Vegetion", value: 9, format: "YYYY" },
                { label: "AOT40 forest protection", value: 10, format: "YYYY" },
                { label: "Period", value: 999, format: "DD/MM HH:mm" },
            ],
        };
    },
    computed: {
        filteredTimeseries() {
            return this.timeseriesWithinDateRange.filter((f) => {
                return f.label.toUpperCase().indexOf(this.q.toUpperCase()) !== -1;
            });
        },
        timeseriesWithinDateRange() {
            return this.timeseries.filter((f) => {
                if (!f.fromtime && !f.totime) return true;

                const from = moment(this.dateRangeFrom);
                const to = moment(this.dateRangeTo);
                const ts_from = moment(f.fromtime);
                const ts_to = moment(f.totime);
                const timeseriesWithinDateRange = ts_to.isAfter(from) && ts_from.isBefore(to);

                return timeseriesWithinDateRange;
            });
        },
        computedFavType() {
            if (this.timeseriesSelection.length == 0) return "";

            const favs = this.timeseriesSelection.find((t) => {
                return t.label == t.value;
            });

            if (favs) return "remove";

            return "add";
        },
    },
    async mounted() {
        // Notify.loadData(null, this.loadInitialData);
        await this.loadInitialData();

        if (this.$route.query.ids) {
            this.preselected = this.$route.query.ids.split(",");
        }

        if (this.preselected.length > 0) {
            var selections = this.timeseries.filter((f) => {
                return this.preselected.includes(f.value);
            });

            var dates = selections.map((p) => p.toTime);
            var f = Object.assign({}, moment.min(dates));
            var t = Object.assign({}, moment.max(dates));
            this.dateRangeFrom = moment(f).add(-4, "days").format("YYYY-MM-DD");
            this.dateRangeTo = moment(t).format("YYYY-MM-DD");

            this.timeseriesSelection = selections;
        }
        if (this.$route.query.from) {
            var f = Object.assign({}, moment.min(dates));
            this.dateRangeFrom = this.$route.query.from;
        }
        if (this.$route.query.to) {
            this.dateRangeTo = this.$route.query.to;
        }
        // if (this.$route.query.datacoverage) {
        //   this.coverage = parseInt(this.$route.query.datacoverage);
        //   this.showCoverageInput = true;
        // }
        if (this.$route.query.onlyvalid) this.onlyValidValues = this.$route.query.onlyvalid == "true";
        if (this.$route.query.viewAsBar) this.viewAsBar = this.$route.query.viewAsBar == "true";
        if (this.$route.query.setYaxisStart) {
            this.yaxisStart = this.$route.query.setYaxisStart;
            this.setYaxisStart = true;
        }
        if (this.preselected.length > 0) this.onClick();
    },
    watch: {
        setYaxisStart: function (val) {
            if (val) {
                if (!this.yaxisStart) this.yaxisStart = 0;
            } else {
                this.yaxisStart = undefined;
            }
        },
    },
    methods: {
        async loadInitialData() {
            const timeseries = await HistoricalService.timeseries();

            let mapped = timeseries.map((t) => {
                return {
                    label: t.label,
                    value: t.value,
                    fromTime: moment(t.fromTime),
                    toTime: moment(t.toTime),
                };
            });
            let favs = LocalService.getAllHistoricFavs();
            for (var p in favs) {
                mapped.unshift({ label: p, value: p });
            }
            this.timeseries = mapped;
        },
        onClick() {
            const ids = [];
            this.timeseriesSelection.forEach((t) => {
                if (t.label == t.value) {
                    const fav = LocalService.getHistoricFav(t.label);
                    fav.forEach((f) => {
                        ids.push(f.value);
                    });
                }
                ids.push(t.value);
            });

            var m = this.meantypes.find((m) => m.value == this.meantype);

            this.$emit("click", {
                timeseries: ids,
                from: this.dateRangeFrom,
                to: this.dateRangeTo,
                onlyValidValues: this.onlyValidValues,
                viewAsBar: this.viewAsBar,
                yaxisStart: this.yaxisStart,
                coverage: this.coverage,
                meantype: this.meantype,
                format: m.format,
            });
        },
        onFavClick(o) {
            if (o.type == "add") {
                let newfav = [];
                this.timeseriesSelection.forEach((t) => newfav.push({ label: t.label, value: t.value }));
                LocalService.setHistoricFav(o.label, newfav);
                this.timeseries.unshift({ label: o.label, value: o.label });
                this.timeseriesSelection = [{ label: o.label, value: o.label }];
            } else if (o.type == "remove") {
                const favs = this.timeseriesSelection.filter((t) => {
                    return t.label == t.value;
                });
                favs.forEach((fav) => {
                    LocalService.removeHistoricFav(fav.label);
                });
                //Remove deleted favs from selection
                const selection = this.timeseriesSelection.filter((t) => {
                    return t.label != t.value;
                });
                this.timeseriesSelection = selection;
                //Remove deleted favs from timeseries
                this.timeseries = this.timeseries.filter((t) => {
                    return !favs.find((fav) => {
                        return fav.value == t.label;
                    });
                });
            }
        },
        getUrlOptions() {
            return window.location.protocol + "//" + window.location.hostname + window.location.pathname + "?" + "&ids=" + Array.prototype.map.call(this.timeseriesSelection, (s) => s.value).toString() + "&onlyvalid=" + this.onlyValidValues + "&viewAsBar=" + this.viewAsBar + "&setYaxisStart=" + this.yaxisStart + "&from=" + this.dateRangeFrom + "&to=" + this.dateRangeTo;
        },
        onCopyUrl(o) {
            this.copyUrl = this.getUrlOptions(); //window.location.protocol + '://' + window.location.hostname + window.location.pathname + '?' + options;
            let urlToCopy = document.querySelector("#hdnCopyUrl");
            urlToCopy.setAttribute("type", "text");
            urlToCopy.select();

            try {
                var successful = document.execCommand("copy");
            } catch (err) {}

            /* unselect the range */
            urlToCopy.setAttribute("type", "hidden");
            window.getSelection().removeAllRanges();
        },
        async onDownloadCsv() {
            this.error = "";
            this.loading = true;

            try {
                const ids = [];
                this.timeseriesSelection.forEach((t) => {
                    if (t.label == t.value) {
                        const fav = LocalService.getHistoricFav(t.label);
                        fav.forEach((f) => {
                            ids.push(f.value);
                        });
                    }
                    ids.push(t.value);
                });

                const sel = {
                    oc_id: ids,
                    from: this.dateRangeFrom,
                    to: this.dateRangeTo,
                    onlyValidValues: this.onlyValidValues,
                    viewAsBar: this.viewAsBar,
                    meantype: this.meantype,
                    coverage: this.coverage,
                };

                if (sel.oc_id.length > 0) {
                    if (this.CsvFormatPivot) {
                        await HistoricalService.timeSeriesCsv(sel, true);
                    } else {
                        await HistoricalService.timeSeriesCsv(sel);
                    }
                }
                this.loading = false;
            } catch (e) {
                this.error = "Something went wrong";
                this.loading = false;
            }
        },
        clearTimeseriesSelection() {
            this.timeseriesSelection = [];
        },
        setDateThisWeek() {
            this.dateRangeFrom = moment().startOf("isoWeek").format("YYYY-MM-DDTHH:mm");
            this.dateRangeTo = moment().add(1, "hour").format("YYYY-MM-DDTHH:mm");
        },
        setDateLastWeek() {
            this.dateRangeFrom = moment().subtract(1, "weeks").startOf("isoWeek").format("YYYY-MM-DDTHH:mm");
            this.dateRangeTo = moment().subtract(1, "weeks").endOf("isoWeek").format("YYYY-MM-DDTHH:mm");
        },
        setDateLastMonth() {
            this.dateRangeFrom = moment().subtract(1, "month").startOf("month").format("YYYY-MM-DDTHH:mm");
            this.dateRangeTo = moment().subtract(1, "month").endOf("month").format("YYYY-MM-DDTHH:mm");
        },
        setDateThisYear() {
            this.dateRangeFrom = moment().startOf("year").format("YYYY-MM-DDTHH:mm");
            this.dateRangeTo = moment().format("YYYY-MM-DDTHH:mm");
        },
        setDateLastYear() {
            this.dateRangeFrom = moment().subtract(1, "year").startOf("year").format("YYYY-MM-DDTHH:mm");
            this.dateRangeTo = moment().subtract(1, "year").endOf("year").format("YYYY-MM-DDTHH:mm");
        },
    },
};
</script>
